import { createListModalContainer } from 'factories/ListModal'
import actions from 'actions/dashboardTemplates'
import Component from 'components/DashboardTemplates/Select'

export default createListModalContainer({ actions })(Component)
